module.exports = __webpack_public_path__ + "img/springroll_fold_2.5b20e871.jpg";